import React, { useState, useRef, useEffect } from 'react'

import { FluidBox } from 'styled'
import { BoxHeading, QuestionBoxRoot, ContentInner, QuestionIcons } from './ThemesPanel.styled'

import { ReactComponent as CorrectIcon } from './../../../assets/correct-icon.svg'
import { ReactComponent as WrongIcon } from './../../../assets/wrong-icon.svg'

const QuestionBox = ({ selected, correct, selectedTheme, setQuestion, question }) => {
  const [headerHeight, setHeaderHeight] = useState()
  const [bodyHeight, setBodyHeight] = useState()
  const { questionId, questionName, questionText, answerInfo, id } = question
  const { text, source } = answerInfo

  const bodyRef = useRef()
  const headerRef = useRef()

  useEffect(() => {
    const bodyHeight = bodyRef.current.scrollHeight
    const headerHeight = headerRef.current.scrollHeight
    setBodyHeight(bodyHeight)
    setHeaderHeight(headerHeight)
  }, [setBodyHeight, setHeaderHeight])

  return (
    <QuestionBoxRoot>
      <ContentInner ref={headerRef} openHeight={headerHeight} open={selectedTheme}>
        <BoxHeading
          selected={selected}
          color={correct ? 'accent' : 'wrong'}
          onClick={setQuestion}
          fs="small"
          tt="uppercase"
          pt="spaceSmall"
          mb="spaceSmall"
        >
          {questionId} of {7} &nbsp;&nbsp; {questionName}
          <QuestionIcons selected={!selectedTheme}>
            {correct ? <CorrectIcon key={id}></CorrectIcon> : <WrongIcon key={id}></WrongIcon>}
          </QuestionIcons>
        </BoxHeading>
      </ContentInner>
      <ContentInner ref={bodyRef} openHeight={bodyHeight} open={selected}>
        <FluidBox color="primary" mb="spaceSmall" lh={1.5}>
          {questionText}
        </FluidBox>
        <FluidBox as="p" mb="spaceSmall" fs="textSmall">
          {text}
        </FluidBox>
        <FluidBox
          as="a"
          href={source.url}
          pb="spaceSmall"
          tt="uppercase"
          fs={12}
          fw="bold"
          td="underline"
        >
          {source.text}
        </FluidBox>
      </ContentInner>
    </QuestionBoxRoot>
  )
}

export default QuestionBox
